import { CommonService } from './../../../../services/utils/common.service';
import { ProvinceService } from './../../../../services/province/province.service';
import { CountryService } from './../../../../services/country/country.service';
import { Report } from './../../../../models/report.model';
import { StoreCommonService } from './../../../../services/store/store-common.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomerCardListModel } from './../../../../models/customer-cards.model';
import { mgCustomerCompany, CustomerBasicInfo, CustomerCompanyData, CustomerFileUpload } from './../../../../models/customer.model';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CustomerInfoService } from './../../../../services/customer/customerinfo.service';
import { FileUpload, MessageService, SelectItem } from 'primeng/primeng';

import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { format } from 'url';
import { LoyaltyReservationsService } from 'app/services/loyalty/loyalty-reservations.service';
import { CustomersService } from '../../../../services/customer/customers.service';
import { ClassificationService } from '../../../../services/classification/classification.service';
import { Classification } from 'app/models/classification.model';

declare var Stimulsoft: any;
declare var $: any;

@Component({
  selector: 'app-upload-mg-company',
  templateUrl: './uploadmgcompany.component.html',
  providers: [],
})
export class UploadmgCompany implements OnInit {

  @Input() customerHostId: string;
  @Input() basicInfo: CustomerBasicInfo;
  @Input() companyInfo: CustomerCompanyData;
  //@Input() cardInfo: Array<CustomerCardListModel>;
  @ViewChild('upload') upload: FileUpload;

  file: File = null;

  currentExistingFiles: Array<CustomerFileUpload> = new Array<CustomerFileUpload>();

  viewer: any;
  pdfReport: Report;
  translations: any;
  customer:mgCustomerCompany;
  card: CustomerCardListModel;
  show = {
    customerInfo: false,
    available: false,
    download: false
  }
  provinces: SelectItem[] = [];
  barcodeCardNo: string = '';
  settore: SelectItem[] = [];

  cardInfo: Array<CustomerCardListModel>;

  @Output() customerHasFiles: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private notifyService: MessageService,
    private srvCust: CustomerInfoService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private srvStoreCommon: StoreCommonService,
    private srvCountry: CountryService,
    private srvProvince: ProvinceService,
    private srvLoyaltyReservations: LoyaltyReservationsService,
    private srvCustomers: CustomersService,
    private classificationService: ClassificationService,
    private srvCommon: CommonService
  ) { }
  ngOnInit(): void {

    //FOR TEST
    /*
    if(this.activatedRoute.snapshot.params['customerId']){
      this.customerHostId = this.activatedRoute.snapshot.params['customerId'];
    }
    */

    const translateObs = this.translate.get([
      'common.all',
      'common.company',
      'common.physicalPerson',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'reportMgCompany.card_title',
      'reportMgCompany.companyname_title',
      'reportMgCompany.pivafiscalcode_title',
      'reportMgCompany.officeemail_title',
      'reportMgCompany.officemobile_title',
      'reportMgCompany.area_title',
      'reportMgCompany.fullname_title',
      'reportMgCompany.fiscalcode_title',
      'reportMgCompany.street_title',
      'reportMgCompany.localita_title',
      'reportMgCompany.province_title',
      'reportMgCompany.zipcode_title',
      'reportMgCompany.informativa_title',
      'reportMgCompany.consenso1_title3',
      'reportMgCompany.consenso2_title3',
      'reportMgCompany.consenso_title_yes',
      'reportMgCompany.consenso_title_no',
      'reportMgCompany.currentdate_title',
      'reportMgCompany.sign_title',
      'upload.upload_success',
      'upload.upload_error',
      'upload.type_error',
      'upload.choose_file',
      'upload.download_error'
    ]);


    //recupero dati
    let search = [
      {key: 'name',value: 'italia' },
      {key: 'flg_state',value: '0'}
    ];

    var CHECKSTORAGEAVILABILITY = this.srvCust.chackStorageAvailability(this.customerHostId);
    var COUNTRIES = this.srvCountry.list(null,null,search);
    //var GETBASICINFO = this.srvCust.getBasicInfo(this.customerHostId);
    //var GETCOMPANYINFO = this.srvCustomers.getCompanyData(this.customerHostId);
    var GETCARDSINFO = this.srvCust.getCards(this.customerHostId);
    var GETCLASSIFICATIONINFO = this.srvCust.getClassification(this.customerHostId);
    var GETFILES = this.srvCust.getFiles(this.customerHostId,"moduli");
    var self = this;

    Observable.zip(
      CHECKSTORAGEAVILABILITY ,
      //GETBASICINFO,
      //GETCOMPANYINFO,
      GETCARDSINFO,
      GETCLASSIFICATIONINFO,
      COUNTRIES,
      GETFILES,
      translateObs)
    .subscribe(([
      resCheck,
      //resBasicInfo,
      //resCompanyInfo,
      resCardsInfo,
      resClassificationInfo,
      resCountries,
      resGetFiles,
      t]) => {


          self.cardInfo = resCardsInfo;

          if(resCheck && !resCheck.error){
            self.show.available = true;
          }
          else{
            self.show.available = false;
          }

          self.translations = t;

          if(resGetFiles && resGetFiles.history){
            self.currentExistingFiles = resGetFiles.history;

            if (resGetFiles.history.length > 0) {
              self.customerHasFiles.emit(true);
            }
          }

          let provinces: Observable<any>;

          if(resCountries){
            if(resCountries.data[0] !== null) {
              provinces = self.srvProvince.getAll(resCountries.data[0].id);
            } else {
              provinces = self.srvProvince.getAll(-1);
            }

            provinces.subscribe(resProvinces=>{
              if(resProvinces){
                for (const province of resProvinces) {
                  self.provinces.push({
                    value: province.id,
                    label: province.name
                  });
                }
              }
              if(this.basicInfo && this.cardInfo){

                let cust:mgCustomerCompany = new mgCustomerCompany();
                //let basicInfo: CustomerBasicInfo;
                //let companyInfo: Array<CustomerCompanyData>;
                let classificationInfo: Array<any>;                

                if(this.basicInfo.customerCode){
                  //console.log('this.basicInfo ', this.basicInfo);
                  //console.log('resCompanyInfo ', resCompanyInfo);
                  //console.log('resClassificationInfo ', resClassificationInfo);
                  //basicInfo = resBasicInfo;
                  //companyInfo = resCompanyInfo ? resCompanyInfo : null;
                  classificationInfo = resClassificationInfo ? resClassificationInfo : null;
                  //cardInfo = resCardsInfo;
                  cust.customerId = +this.basicInfo.id;
                  cust.ragioneSociale = this.companyInfo !== null ? this.companyInfo.company_name : '';
                  cust.partitaIva_codiceFiscale = this.companyInfo !== null ? this.companyInfo.vat_code !== '' ? this.companyInfo.vat_code : this.companyInfo.fiscal_code : '';
                  cust.emailAziendale = this.companyInfo !== null ? this.companyInfo.email_primary : '';
                  cust.mobileAziendale = this.companyInfo !== null ? this.companyInfo.phone_mobile : '';
                  if(classificationInfo !== null){
                    this.classificationService.getTypes('customer').switchMap(classificationTypes => {
                      return this.classificationService.getList(classificationTypes[0].id);
                    }).subscribe(classifications => {
                      this.classificationService.getDetails(classifications[0].id).subscribe(res => {
                        for (const classification of res) {
                          this.settore.push({ label: classification.description, value: classification.id });
                        }
                        if(this.settore.length > 0){
                          cust.settore = this.settore.find(f => f.value.toString() === classificationInfo[0].classification_detail_id.toString()) === undefined ? '' : this.settore.find(f => f.value.toString() === classificationInfo[0].classification_detail_id.toString()).label;
                        }
                      });
                    });
                  }else{
                    cust.settore = '';
                  }
                  cust.nome = this.basicInfo.name;
                  cust.cognome = this.basicInfo.surname;
                  cust.fiscalCode = this.basicInfo.fiscal_code;
                  cust.address = this.basicInfo.address;
                  cust.addressNumber = this.basicInfo.address_number;
                  cust.comune = this.basicInfo.city;
                  cust.zipCode = this.basicInfo.zip_code;
                  cust.province = this.basicInfo.province_id;
                  cust.flgAuth1 = this.basicInfo.flag_privacy;
                  cust.flgAuth2 = this.basicInfo.flag_marketing_activities;
                  cust.flgAuth3 = this.basicInfo.flag_profiling;

                  let card: CustomerCardListModel = null;
                  //prendo la prima che incontro non in blacklist che sono sicuro che è l'ultima associata.
                  for(var i = 0;i<this.cardInfo.length;i++){
                    if(this.cardInfo[i].flagBlackList!="1"){
                      card = this.cardInfo[i];
                      break;
                    }
                  }
                  
                    /*
                  09-05-2022 
                  controllo aggiunto perchè in caso di blacklist non si vedeva l'upload moduli perchè non avevo info sulla carta e perciò 
                  andava in errore.
                  Adesso questo caso non si dovrebbe più presentare in quanto anche in caso di tutte carte in blacklist considero la prima
                  */
                 
                  if(!card && this.cardInfo.length>0){
                    card = this.cardInfo[0];
                    this.show.available = false;
                    this.show.download = false;
                  }
                  else{
                    this.show.download = true;
                    if(resCheck && !resCheck.error){
                      self.show.available = true;
                    }
                    else{
                      self.show.available = false;
                    }
                  }

                  self.card = card;
                  var self2 = self;

                  let indexProvince = self.provinces.findIndex(x=>x.value == cust.province);
                  if(indexProvince>-1){
                    cust["provinceName"] = self.provinces[indexProvince].label;
                  }

                  //if(self.card !== null){
                  //09-05-2022 Modificato perchè in caso di carta in blacklist vale undefined e perciò passava il controllo, erroneamente
                  
                  if(self.card){
                    self.srvStoreCommon.getList(null,null,{id: card.store_id.toString()}).subscribe(res=>{

                      if(res && res.length && res.length>0){
                        cust["storeDescription"] = res[0].name;
                        cust["storeCode"] = res[0].code;
                      }

                      self2.customer = cust;
                      self2.show.customerInfo = true;
                    });

                    if(self.card.cardNo.length < 13){
                      this.barcodeCardNo = this.srvCommon.getCardWithCheckdigit(self.card.cardNo);
                      /*
                      this.srvLoyaltyReservations.getCardCheckDigit(self.card.cardNo).subscribe(res => {
                        if(res && res.length == 13){
                          this.barcodeCardNo = res;
                        }
                      });
                      */
                    }
                  }
                }
              }

            });
          }
        });
  }
  onClearUpload(){
    this.file = null;
  }
  onFileUpload(event, upload) {
    if(event.files[0].type == "application/pdf"){
        var self = this;
      setTimeout(function(){
        self.upload = upload;
        self.file = event.files[0];
      },100);
    }
    else{
      this.notifyService.add({ severity: 'error', detail: this.translations['upload.type_error'] });
    }

  }
  onClickScaricaModuloVuoto() {
    console.log('Genera report cliente - customer ', this.customer);
    // Change report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;


    this.viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
    var stiReport = new Stimulsoft.Report.StiReport();

    stiReport.loadFile("./assets/report/InserimentoClienteAzienda.mrt");

    //negozio
    stiReport.dictionary.variables.getByName("var_store_name_val").valueObject = this.customer["storeDescription"];
    stiReport.dictionary.variables.getByName("var_store_code_val").valueObject = this.customer["storeCode"];

    //carta
    stiReport.dictionary.variables.getByName("var_card_title").valueObject = this.translations['reportMgCompany.card_title'];
    //stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.card.cardNo);

    if(this.card.cardNo.length == 13){
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.card.cardNo);
    }else{
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.barcodeCardNo);
    }

    //info cliente azienda
    stiReport.dictionary.variables.getByName("var_companyname_title").valueObject = this.translations['reportMgCompany.companyname_title'];
    stiReport.dictionary.variables.getByName("var_companyname_val").valueObject = this.customer.ragioneSociale;

    stiReport.dictionary.variables.getByName("var_pivafiscalcode_title").valueObject = this.translations['reportMgCompany.pivafiscalcode_title'];
    stiReport.dictionary.variables.getByName("var_pivafiscalcode_val").valueObject = this.customer.partitaIva_codiceFiscale;

    stiReport.dictionary.variables.getByName("var_officeemail_title").valueObject = this.translations['reportMgCompany.officeemail_title'];
    stiReport.dictionary.variables.getByName("var_officeemail_val").valueObject = this.customer.emailAziendale;

    stiReport.dictionary.variables.getByName("var_officemobile_title").valueObject = this.translations['reportMgCompany.officemobile_title'];
    stiReport.dictionary.variables.getByName("var_officemobile_val").valueObject = this.customer.mobileAziendale;

    stiReport.dictionary.variables.getByName("var_area_title").valueObject = this.translations['reportMgCompany.area_title'];
    stiReport.dictionary.variables.getByName("var_area_val").valueObject = this.customer.settore;

    stiReport.dictionary.variables.getByName("var_fullname_title").valueObject = this.translations['reportMgCompany.fullname_title'];
    stiReport.dictionary.variables.getByName("var_fullname_val").valueObject = this.customer.nome + ' ' + this.customer.cognome;

    stiReport.dictionary.variables.getByName("var_fiscalcode_title").valueObject =this.translations['reportMgCompany.fiscalcode_title'];
    stiReport.dictionary.variables.getByName("var_fiscalcode_val").valueObject = this.customer.fiscalCode;

    stiReport.dictionary.variables.getByName("var_street_title").valueObject = this.translations['reportMgCompany.street_title'];
    stiReport.dictionary.variables.getByName("var_street_val").valueObject = this.customer.address + " " + this.customer.addressNumber;

    stiReport.dictionary.variables.getByName("var_localita_title").valueObject = this.translations['reportMgCompany.localita_title'];
    stiReport.dictionary.variables.getByName("var_localita_val").valueObject = this.customer.comune;

    stiReport.dictionary.variables.getByName("var_province_title").valueObject = this.translations['reportMgCompany.province_title'];
    stiReport.dictionary.variables.getByName("var_province_val").valueObject = this.customer["provinceName"] ? this.customer["provinceName"] : "";

    stiReport.dictionary.variables.getByName("var_zipcode_title").valueObject = this.translations['reportMgCompany.zipcode_title'];;
    stiReport.dictionary.variables.getByName("var_zipcode_val").valueObject = this.customer.zipCode;

    //informativa
    stiReport.dictionary.variables.getByName("var_informativa_title").valueObject = this.translations['reportMgCompany.informativa_title'];
    stiReport.dictionary.variables.getByName("var_informativa_val").valueObject = (this.customer.flgAuth1 == true || this.customer.flgAuth1 == "1") ? "X" : "";

    //consenso prima riga
    stiReport.dictionary.variables.getByName("var_consenso1_title1").valueObject = this.translations['reportMgCompany.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso1_val1").valueObject = (this.customer.flgAuth2 == true || this.customer.flgAuth2 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title2").valueObject = this.translations['reportMgCompany.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso1_val2").valueObject = (!this.customer.flgAuth2 || this.customer.flgAuth2 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title3").valueObject = this.translations['reportMgCompany.consenso1_title3'];

    //consenso seconda riga
    stiReport.dictionary.variables.getByName("var_consenso2_title1").valueObject = this.translations['reportMgCompany.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso2_val1").valueObject = (this.customer.flgAuth3 == true || this.customer.flgAuth3 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title2").valueObject = this.translations['reportMgCompany.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso2_val2").valueObject = (!this.customer.flgAuth3 || this.customer.flgAuth3 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title3").valueObject = this.translations['reportMgCompany.consenso2_title3'];

    //data e firma
    stiReport.dictionary.variables.getByName("var_currentdate_title").valueObject = this.translations['reportMgCompany.currentdate_title'];
    stiReport.dictionary.variables.getByName("var_currentdate_val").valueObject = moment(new Date()).format("DD/MM/YYYY");
    stiReport.dictionary.variables.getByName("var_sign_title").valueObject = this.translations['reportMgCompany.sign_title'];

    //Render report
    stiReport.render();
    this.viewer.report = stiReport;

    // Export and Download to PDF
    this.viewer.report.exportDocumentAsync((pdfData) => {
      var buffer = Buffer.from(pdfData)
      var blob = new Blob([buffer], {type: "application/pdf"});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = this.basicInfo ? (this.basicInfo.customerCode + "_" + moment(new Date()).format('DD_MM_YYYY') + ".pdf") : "report-company.pdf";
      link.download = fileName;
      link.click();

      console.log("Rendered report saved into PDF-file.");
    }, Stimulsoft.Report.StiExportFormat.Pdf);
  }

  getBarcodeImageByCardNo(cardNo: string){

    var JsBarcode = require('jsbarcode')

    JsBarcode("#barcode", cardNo, {
      format: "EAN13",
      lineColor: "#000",
      width:2,
      height:40,
      displayValue: true
    });

    var svg = $("#barcode")[0];

    var xml = new XMLSerializer().serializeToString(svg);

    var base64 = 'data:image/svg+xml;base64,' + btoa(xml);

    return base64;
  }

  onClickSave(){

    if(this.file){

      if(this.file.type == "application/pdf"){
        var self = this;
        this.srvCust.uploadMgFile(this.file,this.customerHostId,"moduli").subscribe(res=>{

          if(res){
            self.notifyService.add({severity: 'success', detail: this.translations['upload.upload_success']});
            self.currentExistingFiles.unshift(res);
            this.customerHasFiles.emit(true);
          }
          else{
            self.notifyService.add({severity: 'error', detail: this.translations['upload.upload_error']});
            self.onClearUpload();
          }
          self.upload.clear();
          self.onClearUpload();
        });
      }

    }
  }
  onClickShowFile(currentExistingfile: CustomerFileUpload){
    var self = this;
    this.srvCust.getFileByBase64(this.customerHostId,currentExistingfile.storageFileName,"moduli").subscribe(res=>{
      if(res){        
        var blob = new Blob([res], {type: "application/pdf"});
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var fileName = currentExistingfile.originalFileName;
        link.download = fileName;
        link.click();
      }
      else{
        self.notifyService.add({severity: 'error', detail: this.translations['upload.download_error']});
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/upload-mg-company/uploadmgcompany.component.ts